import { render, staticRenderFns } from "./WheelColumn.vue?vue&type=template&id=947c324a&scoped=true"
import script from "./WheelColumn.vue?vue&type=script&lang=js"
export * from "./WheelColumn.vue?vue&type=script&lang=js"
import style0 from "./WheelColumn.vue?vue&type=style&index=0&id=947c324a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "947c324a",
  null
  
)

export default component.exports